/**
 * getFeatureNameFromArea gets the KnownFeatureName from the given area for OTEL telemetry logging.
 * @param area The area of the feature, such as "Edgeworth", "MyContentOdspView", "Recommended"
 * @return The KnownFeatureName for logFeature() to use for telemetry purposes.
 */
var featureNameDefinition = {
    AppBar: "AppBar" /* KnownFeatureNames.AppBar */,
    AppList: "AppGallery" /* KnownFeatureNames.AppGallery */,
    AppsNotificationDialog: "AppsNotificationDialog" /* KnownFeatureNames.AppsNotificationDialog */,
    Edgeworth: "Edgeworth" /* KnownFeatureNames.Edgeworth */,
    Recommended: "Recommended" /* KnownFeatureNames.Recommended */,
    QuickAccess: "QuickAccess" /* KnownFeatureNames.QuickAccess */,
    MyContent: "MyContent" /* KnownFeatureNames.MyContent */,
    MyContentOdspView: "MyContent" /* KnownFeatureNames.MyContent */,
    MyContentPeopleView: "MyContent" /* KnownFeatureNames.MyContent */,
    MyContentPeopleViewDetailed: "MyContent" /* KnownFeatureNames.MyContent */,
    TuiCallout: "TeachingUi" /* KnownFeatureNames.TeachingUi */,
    GettingToKnowYou: "GettingToKnowYou" /* KnownFeatureNames.GettingToKnowYou */,
};
export function getFeatureNameFromArea(area) {
    if (!area) {
        return "Other" /* KnownFeatureNames.Other */;
    }
    var featureName = featureNameDefinition[area];
    return featureName !== null && featureName !== void 0 ? featureName : "Other" /* KnownFeatureNames.Other */;
}
//# sourceMappingURL=getFeatureNameFromArea.js.map